var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "card_membership"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_693_1411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_693_1411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "card_membership_2",
    d: "M3.33341 10.8332V12.4998H16.6667V10.8332H3.33341ZM3.33341 1.6665H16.6667C17.1251 1.6665 17.5174 1.8297 17.8438 2.15609C18.1702 2.48248 18.3334 2.87484 18.3334 3.33317V12.4998C18.3334 12.9582 18.1702 13.3505 17.8438 13.6769C17.5174 14.0033 17.1251 14.1665 16.6667 14.1665H13.3334V18.3332L10.0001 16.6665L6.66675 18.3332V14.1665H3.33341C2.87508 14.1665 2.48272 14.0033 2.15633 13.6769C1.82994 13.3505 1.66675 12.9582 1.66675 12.4998V3.33317C1.66675 2.87484 1.82994 2.48248 2.15633 2.15609C2.48272 1.8297 2.87508 1.6665 3.33341 1.6665ZM3.33341 8.33317H16.6667V3.33317H3.33341V8.33317Z",
    fill: "url(#paint0_linear_693_1411)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_693_1411",
    x1: 10.0001,
    y1: 1.6665,
    x2: 10.0001,
    y2: 18.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.4c2743fd89e31bc1e1ff20ff98cb8d07.svg";
export { ForwardRef as ReactComponent };